export default {"src":"/_next/static/media/binance-labs.a25f145c.svg","height":30,"width":120,"blurWidth":0,"blurHeight":0};